import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { convertHexToRgba } from '@utils/cssHelpers'
import styled from 'styled-components'

const Styles = styled.section<any>`
  padding: 0;
  margin: 0 0;

  .room {
    margin: 0 0 48px;
    @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
      margin: 0 0 8px 0 !important;
    }
  }

  .aligner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--bs-mch-white);

    &-item {
      flex: 1;
      text-align: center;
      @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
        padding: 60px 0 35px;
      }

      &--fixed {
        flex: none;
        max-width: 50%;
        @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
          max-width: 75%;
        }
      }
    }
  }

  .dark {
    .preview-container {
      background: var(--bs-mch-black);

      h4 {
        color: var(--bs-mch-white) !important;
      }

      .label {
        color: var(--bs-mch-white) !important;
      }

      button {
        background: var(--bs-mch-white);
        color: var(--bs-mch-black);
      }
    }
  }

  .preview-container {
    background: var(--bs-mch-white);

    .only-for-vip * {
      color: ${convertHexToRgba(tokens.color.light.base.neutrals[0].value, tokens.opacity[50].value)};
    }

    .aligner-item--fixed {
      max-width: 90%;
    }

    .preview-account {
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      @media only screen and (min-width: ${global.uikitVars.breakpointMd}) and (max-width: ${global.uikitVars.breakpointMdMax}) {
        margin-top: 16px;
      }
      @media only screen and (max-width: ${global.uikitVars.breakpointSmMax}) {
        margin-top: 16px;
      }
    }

    .preview-room {

      @media (min-width: 1480px) {
        -webkit-line-clamp: 4;
      }

      @media (min-width: 1200px) {
        -webkit-line-clamp: 3;
      }
    }

    .preview-image {
      @media only screen and (min-width: ${global.uikitVars.breakpointLg}) {
        .image-wrapper {
          height: 100%;
          position: relative;
        }
      }
      @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
        position: relative;
      }

      .aligner {
        background: rgba(${convertHexToRgba(tokens.color.light.base.neutrals[900].value, tokens.opacity[80].value)});
        height: 100%;
        position: absolute;
        z-index: 1;
        top: 0;
        width: 100%;

        &-item {
          padding: 0;

          &--fixed {
            max-width: 90%;
          }
        }
      }
    }
  }

  .closing-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: rgba(${convertHexToRgba(tokens.color.light.base.neutrals[900].value, tokens.opacity[80].value)});
    color: var(--bs-mch-white);
    padding: 25px 40px 29px 40px;
    @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
      padding: 12px 24px 8px 24px;
    }

    & > div {
      @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
        display: flex;
        flex-direction: column;
      }
    }

    .seven.wide.computer.column {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    @media only screen and (max-width: ${global.uikitVars.breakpointMdMax}) {
      .ui.grid .row {
        .column:first-child {
          padding-right: 0;
        }
        .column:last-child {
          padding-left: 0;
        }
      }
    }

    .closing-date,
    .closing-city {
      text-align: right;
    }
  }
`

export default Styles
